import { render } from "./AnimatedLikeEntity.vue?vue&type=template&id=1d0a3c5c&ts=true"
import script from "./AnimatedLikeEntity.vue?vue&type=script&lang=ts"
export * from "./AnimatedLikeEntity.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__